import { useState } from 'react';
import './card.css'
import StudentCardDetailsPopup from '../StudentCardDetails/StudentCardDetails';

const statusEffectMap = {
    CONFIRMED: {
        boxShadow: "0 0 9px rgba(40, 167, 69, 1)",
        backgroundColor: "rgba(40, 167, 69, 1)",
    },
};

export default function Card({ tuition, onMarkAttendance }) {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <div className="card">
            <div className='main-content'>
                <div className='details-section'>
                    <div className='item-div'>
                        <img src="card-person-icon.svg" alt="card-person-icon" className='img-style' />
                        <span className='item-text'>{tuition.student_name}</span>
                    </div>
                    <div className='item-div'>
                        <img src="card-subject-icon.svg" alt="card-subject-icon" className='img-style' />
                        <span className='item-subtext'>Subject: {tuition.subject}</span>
                    </div>
                    <div className='item-div'>
                        <img src="card-subject-icon.svg" alt="card-grade-icon" className='img-style' />
                        <span className='item-subtext'>Grade: {tuition.grade}</span>
                    </div>
                    <div className='item-div'>
                        <img src="card-subject-icon.svg" alt="card-calendar-icon" className='img-style' />
                        <span className='item-subtext'>Classes/Week : {tuition.classes_per_week}</span>
                    </div>
                    <div className='item-div' title={tuition.address}>
                        <img src="card-address-icon.svg" alt="card-address-icon" className='img-style' />
                        <span className='item-subtext'>{tuition.address || "Address"}</span>
                    </div>
                    <div className='item-div'>
                        <img src="card-subject-icon.svg" alt="card-compensation-icon" className='img-style' />
                        <span className='item-subtext'>₹ {tuition.compensation}</span>
                    </div>
                </div>
                <span 
                    className='view-detail-text' 
                    style={{ cursor: 'pointer' }} 
                    onClick={() => setShowPopup(true)}
                >
                    View details
                </span>
                {showPopup && (
                    <StudentCardDetailsPopup 
                        cardId={tuition.deal_id} 
                        onClose={() => setShowPopup(false)} 
                    />
                )}
            </div>
            <div className='action-div'>
                <div className='action-wrapper'>
                    <div className='status-div'>
                        <span className='status-text'>{tuition.status || "Confirmed"}</span>
                        <div className='status-dot' style={{
                            boxShadow: statusEffectMap['CONFIRMED']?.boxShadow,
                            backgroundColor: statusEffectMap['CONFIRMED']?.backgroundColor,
                        }}></div>
                    </div>
                    <div className='call-location-wrapper'>
                        <div className='actions-wrapper'>
                            <span className='actions-text'>Call Student</span>
                            <a href={`tel:${tuition.phone}`} className='action-link'>
                                <img src="phone-dial-icon.svg" alt="call-to-action-icon" className='action-icon' />
                            </a>
                        </div>
                        <div className='actions-wrapper'>
                            <span className='actions-text'>View location</span>
                            <a href={`https://www.google.com/maps/search/?api=1&query=${tuition.latitude},${tuition.longitude}`} target="_blank" rel="noreferrer" className='action-link'>
                                <img src="location.svg" alt="location-icon" className='action-icon' />
                            </a>
                        </div>
                    </div>
                </div>
                <button className='mark-attendance-btn' onClick={onMarkAttendance}>Mark Attendance</button>
            </div>
        </div>
    )
}